module.exports = {
  onboardingPaths: {
    onboarding: () => '/onboarding',
    accreditation: () => '/onboarding/accreditation',
    reaccreditation: () => '/reaccreditation',
    verification: () => '/onboarding/verification',
  },
};
